import {
  CHANGE_SETTING,
  CHANGE_SETTINGS,
} from 'common/actions/settings';

const key = 'reduxPersist:settings';

export default function settings(
  state = localStorage[key] ? JSON.parse(localStorage[key]) : {},
  action,
) {
  switch (action.type) {
    case CHANGE_SETTING: {
      const newState = Object.assign({}, state, {
        [action.key]: action.value,
      });
      localStorage[key] = JSON.stringify(newState);
      return newState;
    }
    case CHANGE_SETTINGS: {
      const newState = Object.assign({}, state, action.mapping);
      localStorage[key] = JSON.stringify(newState);
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/settings.js